<template>
  <div>
    <strong>{{activity.task.title}}</strong>
    was
    <strong>{{activity.translated_key}}</strong>
    in
    <router-link :to="{ name: 'project', params: { id: activity.project_id } }">
      {{activity.project_name}}
    </router-link>
    on
    {{activity.created_at | formatDate}}

  </div>
</template>

<script>
export default {
  props: {
    activity: {
      type: Object
    }
  },
}
</script>
